import { FC } from 'react'

import { Box, Grid, ProgressBar, Text } from '@factorialco/deprecated-design-system'
import { ProjectTaskAnalyticsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'

interface ProjectTaskAnalyticsProps {
  projectId: string
}

const ProjectTaskAnalytics: FC<ProjectTaskAnalyticsProps> = ({ projectId }) => {
  const { data } = useQuery(ProjectTaskAnalyticsDocument, {
    variables: {
      projectIds: [projectId],
      completed: true,
      overdue: true,
    },
  })

  const taskTotalCount = data?.projectManagement.total.totalCount || 0

  const completedTasksCount = data?.projectManagement.completed.totalCount || 0

  const overdueTasksCount = data?.projectManagement.overdue.totalCount || 0

  return (
    <Grid variant="fixed">
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Counter
          title={i18n.t('project_management.tasks.analytics.task_created')}
          totalCount={taskTotalCount}
        />
      </Box>
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard
          title={i18n.t('project_management.tasks.analytics.task_completed')}
          titleGap="s0"
        >
          <Box gap="s4">
            <Text.Header2 weight="semibold">{`${completedTasksCount} / ${taskTotalCount}`}</Text.Header2>
            <ProgressBar
              amount={completedTasksCount}
              total={taskTotalCount}
              progressColor="viridian1000"
            />
          </Box>
        </InsightCard>
      </Box>
      <Box gridColSpan={{ xxs: 12, s: 4 }}>
        <InsightCard.Counter
          title={i18n.t('project_management.tasks.analytics.task_overdue')}
          totalCount={overdueTasksCount}
        />
      </Box>
    </Grid>
  )
}

export default ProjectTaskAnalytics
